import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useMaintenanceTypesApi } from "../../../http/maintenanceTypes/api";
import { UpsertMaintenanceType } from "../../../http/maintenanceTypes/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import MaintenanceTypeForm, { MaintenanceTypeFormBody } from "./MaintenanceTypeForm";

const CreateMaintenanceTypeButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maintenanceTypesApi = useMaintenanceTypesApi();

  const onSubmit = async (data: MaintenanceTypeFormBody) => {
    const body: UpsertMaintenanceType = {
      name: data.name,
    };

    setIsSubmitting(true);
    try {
      await maintenanceTypesApi.insertAdminMaintenanceType(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.maintenanceTypes.new}>
          <MaintenanceTypeForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateMaintenanceTypeButton;
